import { CustomErrorType } from "../interfaces/CustomErrorType";

export default {
    code: 'ERR_INSUFFICIENT_REWARD_POINT',
    statusCode: 400,
    message: {
        en: 'Insufficient Reward Point',
    },
} as CustomErrorType;